import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogShellComponent } from '../../blog-shell/blog-shell.component';
import { TranslationSyncService } from '../../../../services/translation-sync.service';
import { BlogEntryBase } from '../../shared/blog-entry-base';

@Component({
  selector: 'app-etl-in-finance',
  standalone: true,
  imports: [BlogShellComponent, CommonModule],
  templateUrl: './etl-in-finance.component.html',
  styleUrls: ['./etl-in-finance.component.css']
})
export class EtlInFinanceComponent extends BlogEntryBase {
  constructor(sync: TranslationSyncService) {
    super(sync);
  }
}
